import appUserRoles from "../app/appUserRoles";

const appTypeAvailabilityRoles = [
  appUserRoles.Admin,
  appUserRoles.ApplicationManager,
  appUserRoles.ContentManager,
  appUserRoles.MarketAdmin
];

export default appTypeAvailabilityRoles;
